import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets window scroll on route change.
 * - If the URL has a hash (e.g. /politics#contato), scroll to that anchor.
 *   Retries a few times to handle async page mounts.
 * - Otherwise, scroll to top.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      let attempts = 0;
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }
        attempts += 1;
        if (attempts < 10) {
          setTimeout(tryScroll, 80);
        } else {
          window.scrollTo({ top: 0, left: 0, behavior: "auto" });
        }
      };
      tryScroll();
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
}
